module.exports = __webpack_public_path__ + "media/assets/ArrowLeftGrey-47378bc2c75ea9a6ba6014016881c6d6.svg";